import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const Materialize = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="Materialize"
    height={height}
    width={width}
    title="Materialize logo"
    titleId="materizalize-logo-title"
    viewBox="0 0 67 56"
    {...props}
  >
    <g clipPath="url(#Frame_clip0-16-34)">
      <path
        opacity="0.7"
        d="M67.2686 -0.391989V7.81111L67.2564 56.3767H54.08V4.38441L58.2096 0.179307C58.384 -0.0091926 58.597 -0.157792 58.8341 -0.256392C59.0712 -0.354992 59.3267 -0.401289 59.5832 -0.391989H67.2686Z"
        fill="#472F85"
      />
      <path
        opacity="0.7"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.1165 37.9003C46.1869 36.7083 45.2596 35.5194 44.3496 34.6093C42.6661 32.9318 40.9946 31.2424 39.3243 29.5543C38.4908 28.7118 37.6575 27.8697 36.8233 27.0295V21.1866L36.8261 21.1745C36.8186 20.9179 36.8666 20.6628 36.9667 20.4265C37.0334 20.2693 37.1221 20.1229 37.2298 19.9916L50.0032 7.7547V8.408V39.6833C50.0024 39.7274 50.004 39.8796 50.0061 40.0749C50.0108 40.5281 50.018 41.2131 50.0032 41.3143C49.0494 40.3786 48.0816 39.1378 47.1165 37.9003Z"
        fill="#472F85"
      />
      <path
        d="M-0.344299 14.7681V33.2004L22.9123 56.3767H41.407L-0.344299 14.7681Z"
        fill="#472F85"
      />
      <path d="M-0.344299 56.3767H16.7504L-0.344299 39.3445V56.3767Z" fill="#472F85" />
      <path
        d="M47.642 56.3767H65.9552L10.7228 0.179794C10.5484 -0.0085061 10.3355 -0.157005 10.0985 -0.255505C9.8615 -0.354005 9.606 -0.400204 9.3495 -0.390904H-0.325897V7.8037L47.642 56.3767Z"
        fill="#472F85"
      />
    </g>
    <defs>
      <clipPath id="Frame_clip0-16-34">
        <rect width="67" height="56" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
